export default {
    name: 'viewport',
    props: {
        title: String,
        className: String
    },
    template: require('../../../../../../components/templates/viewport.pug')
};
